import {applyMiddleware, createStore} from 'redux'
import {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import reducers from '../reducers'
import thunk from "redux-thunk"

const persistConfig = {
    key: '3fts',
    storage: storage,
    whitelist: ['login', 'token', 'licence', 'club'] // On indique au reducer ce qu'on souhaite stocker
}
const pReducer = persistReducer(persistConfig, reducers)
const store = createStore(pReducer, applyMiddleware(thunk))
const persistor = persistStore(store)
export {persistor, store}
